RivalIQ.apps.Share.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.CloneIntoAccount = Backbone.Model.extend({
        url: '/api/cloneLandscapeIntoAccount'
    });

});
